import React from 'react';

import * as S from './AmenitiesList.styles';

import AmenitiesIconSelector from '../../../../../shared/components/AmenitiesIconSelector';
import {PrimaryLink} from '../../../CommonStyleUtils/dwebCommon.styles';
import {defaultTheme} from '@stencil/build-theme';

const AmenitiesList = ({list}: {list: Array<string>}) => {
  const hasMore = list.length > 2;

  if (!list.length) return null;

  return (
    <>
      {list.map((item, index) => {
        if (index < 2) {
          return (
            <S.IconWrapperDiv key={index + item} padding="0 1rem 0 0">
              <AmenitiesIconSelector
                name={item}
                height="1.5rem"
                width="1.5rem"
                fill={defaultTheme.colors.downriver.medium}
              />
              <S.TextWrapper>{item}</S.TextWrapper>
            </S.IconWrapperDiv>
          );
        }
      })}
      {(hasMore && (
        <S.HoverTargetWrapperDiv>
          <PrimaryLink>+ more</PrimaryLink>
          <S.HiddenDropdownWrapperDiv top={'1rem'}>
            <S.TopDiv>
              <S.ListDropDownWrapper>
                <S.IconWrapperDiv>
                  <S.TextBlockDDHeading>
                    <S.TextBlockDDHeadingSpan>
                      <S.MiniIconWrapperSpan>
                        <AmenitiesIconSelector
                          styleProps={{
                            height: '1.2rem',
                            width: '1.2rem',
                            fill: defaultTheme.colors.goBrandBlue.base,
                          }}
                          name={'Swimming'}
                        />
                      </S.MiniIconWrapperSpan>
                      <S.AmenitiesHoverTitleSpan>Amenities</S.AmenitiesHoverTitleSpan>
                    </S.TextBlockDDHeadingSpan>
                  </S.TextBlockDDHeading>
                </S.IconWrapperDiv>
                {list.map((item, index) => {
                  if (index >= 2 && index < 8) {
                    return (
                      <S.IconWrapperDiv key={index + item}>
                        <AmenitiesIconSelector
                          name={item}
                          height={'1.5rem'}
                          width={'1.5rem'}
                          fill={defaultTheme.colors.downriver.medium}
                        />
                        <S.TextWrapper>{item}</S.TextWrapper>
                      </S.IconWrapperDiv>
                    );
                  }
                })}
              </S.ListDropDownWrapper>
              <S.TipPositioning />
            </S.TopDiv>
          </S.HiddenDropdownWrapperDiv>
        </S.HoverTargetWrapperDiv>
      )) ||
        ''}
    </>
  );
};

export default AmenitiesList;
